var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.697,
    height: 40,
    viewBox: "0 0 57.697 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d4bc9e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8.848)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.576,34.3a7.273,7.273,0,1,0,7.273,7.273A7.281,7.281,0,0,0,43.576,34.3Zm0,10.909a3.636,3.636,0,1,1,3.636-3.636A3.64,3.64,0,0,1,43.576,45.212Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.727,34.3A7.273,7.273,0,1,0,26,41.576,7.281,7.281,0,0,0,18.727,34.3Zm0,10.909a3.636,3.636,0,1,1,3.636-3.636A3.64,3.64,0,0,1,18.727,45.212Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.473,13.486a1.819,1.819,0,0,0-1.625-1H37.273v3.636h8.455l4.951,9.847,3.25-1.634Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.758,
    height: 3.636,
    transform: "translate(24.364 39.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.273,39.818H6.97a1.818,1.818,0,1,0,0,3.636h6.3a1.818,1.818,0,1,0,0-3.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57.315,28.7,53.739,24.1a1.816,1.816,0,0,0-1.436-.7H39.091V10.667a1.818,1.818,0,0,0-1.818-1.818H6.97a1.818,1.818,0,1,0,0,3.636H35.455V25.212a1.818,1.818,0,0,0,1.818,1.818h14.14l2.648,3.411v9.377H49.03a1.818,1.818,0,1,0,0,3.636h6.848A1.818,1.818,0,0,0,57.7,41.636V29.818A1.821,1.821,0,0,0,57.315,28.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.152,30.606H4.788a1.818,1.818,0,0,0,0,3.636h8.364a1.818,1.818,0,0,0,0-3.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.333,23.454H1.818a1.818,1.818,0,0,0,0,3.636H17.333a1.818,1.818,0,0,0,0-3.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.3,16.3H4.788a1.818,1.818,0,0,0,0,3.636H20.3a1.818,1.818,0,0,0,0-3.636Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.4be6f34bd1887a4020da090d5b986cda.svg";
export { ForwardRef as ReactComponent };